import { createSlice } from "@reduxjs/toolkit";
import { getRequestWithdraws } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  withdraws: ResponseData<IOperator[]> & PaginationResponse | null,
  isWithdrawLoading: boolean,
  isWithdrawSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  withdraws: null,
  isWithdrawLoading: false,
  isWithdrawSuccess: false,

  error: {},
};

const RewardSlice = createSlice({
  name: "Withdraw",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get withdraws
    builder.addCase(getRequestWithdraws.pending, (state: IState, action: any) => {
      state.isWithdrawLoading = true
    });
    builder.addCase(getRequestWithdraws.fulfilled, (state: IState, action: any) => {
      state.withdraws = action.payload.data;
      state.isWithdrawSuccess = true;
      state.isWithdrawLoading = false;
    });
    builder.addCase(getRequestWithdraws.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isWithdrawSuccess = false;
      state.isWithdrawLoading = false;
    });
  },
});

export default RewardSlice.reducer;
